export default "__VITE_ASSET__xTH51BCA__"